import hfConfig from 'hfConfig';
import * as THD from 'hfs.global.namespace';
import cookieUtils from 'cookie-utils';
import $ from 'jquery';

const headerCart = {};

// if there are only blinds products in the cart then we need to update the cart link
headerCart.updateCartUrl = function _updateCartUrl(cartBtn) {
  const blinds = headerCart.blinds;
  const mini = headerCart.mini;

  const cartLink = (blinds > 0 && mini === 0)
    ? 'https://' + headerCart.determineBlindsHostName() + '/Ordering/Cart'
    : '//' + headerCart.hostNameNonSecure() + '/' + headerCart.cartURLWithThrottle();

  cartBtn.setAttribute('href', cartLink);
};

// looks like this function is not used - can this be removed?
headerCart.updateCartUrlforSecure = function _updateCartUrlforSecure(cartElement) {
  let newCartLink;
  if (location.protocol == 'https:') {
    newCartLink = 'https://' + hfConfig.secureHostName + '/mycart/home';
  }
  cartElement.setAttribute('href', newCartLink);
};

// sets the blinds host name
headerCart.determineBlindsHostName = function determineBlindsHostName() {
  return (window.location.host.indexOf('hd-') === -1)
    ? 'blinds.homedepot.com'
    : 'qa-blinds.' + hfConfig.nonSecureHostName;
};

// sets the protocol
/* istanbul ignore next */
headerCart.determineHostName = function determineHostName() {
  return window.location.protocol === 'http:'
    ? hfConfig.nonSecureHostName
    : hfConfig.secureHostName;
};

// wrapper to get non secure domain for desktop-tablet checkout
headerCart.hostNameNonSecure = function hostNameNonSecure() {
  return hfConfig.nonSecureHostName;
};

// determine if the drop down should be shown if we have blinds and merch in the cart
headerCart.showCartDropdown = function showCartDropdown() {
  return headerCart.blinds !== '0' && headerCart.mini !== '0';
};

// determines if to make "blinds item(s)" plural
headerCart.blindsPlural = function blindsPlural() {
  return headerCart.blinds >= 2 ? 's' : '';
};

// determines if to make "cart item(s)" plural
headerCart.miniPlural = function miniPlural() {
  return headerCart.mini >= 2 ? 's' : '';
};

// calculate the cart total to show
headerCart.total = function getTotal() {
  const blinds = headerCart.blinds;
  const mini = headerCart.mini;
  const total = (blinds + mini);

  return total > 99 ? '99+' : total;
}

// calculate the number of items in cart based off of the THD_MINICART cookie crumb
headerCart.getMinicartItemCount = function getMinicartItemCount(cookie) {
  const THD_PERSIST_COOKIE_NAME = 'THD_PERSIST=';
  const MINI_CART_COUNT_PROPERTY = 'I1';
  const THD_MINICART_CRUMB_NAME = 'C6=';
  const THD_MINICART_CRUMB_END_CHARS = '}:;';

  // if the THD_PERSIST cookie isn't there, then we cannot find the crumb with the cart item count
  if (cookie.indexOf(THD_PERSIST_COOKIE_NAME) === -1) {
    return 0;
  }

  const decodedCookie = decodeURIComponent(cookie);

  // if we do not see a C6 cookie crumb, then we cannot parse the cart item count
  if (decodedCookie.indexOf(THD_MINICART_CRUMB_NAME) === -1) {
    return 0;
  }

  // need to offset by 3 so we don't include the actual 'C6=' name in the minicart string
  const minicartCrumbStartIndex = decodedCookie.indexOf(THD_MINICART_CRUMB_NAME) + 3;
  // offsetting by 1 just so we can include the '}' in the indexOf call, to make it more failure proof
  // and to make sure that the ending curly bracket is included in the minicart string
  const minicartCrumbEndIndex = decodedCookie.indexOf(THD_MINICART_CRUMB_END_CHARS, minicartCrumbStartIndex) + 1;
  const thdMiniCartString = decodedCookie.substring(minicartCrumbStartIndex, minicartCrumbEndIndex);

  let minicartItemCount;
  try {
    let miniCartCookieObject = JSON.parse(thdMiniCartString);
    minicartItemCount = headerCart.forceInteger(miniCartCookieObject[MINI_CART_COUNT_PROPERTY]);
  } catch (_) {
    // if the format of the cookie ever changes, the parse might throw an exception
    // in that situation we want to display 0 for the mini-cart count
    minicartItemCount = 0;
  }

  return minicartItemCount;
}

headerCart.getCartItemsText = function _getCartItemsText(itemCount) {
  const unit = ((parseInt(itemCount, 10) === 1) ? 'item' : 'items');
  return (unit);
};

// updates the cart totals
headerCart.updateCartTotal = function _updateCartTotal(cartBtn) {
  const total = headerCart.total();
  const isCartEmpty = headerCart.isCartEmpty();

  let cartReminder__ItemCount = document.getElementById('cartReminder__ItemCount');
  if (cartReminder__ItemCount) cartReminder__ItemCount.textContent = total;

  cartBtn.querySelector('.MyCart__itemCount').textContent = total;
  
  let MyCart__itemCount__label = cartBtn.querySelector('.MyCart__itemCount__label');
  if (MyCart__itemCount__label) MyCart__itemCount__label.textContent = headerCart.getCartItemsText(total);

  cartBtn.querySelector('.HeaderCartIcon')?.
    classList.toggle('hide', isCartEmpty);
  cartBtn.querySelector('.MyCart__contents')?.
    classList.toggle('hide', isCartEmpty);

  return headerCart;
};

// replete means "filled"
headerCart.isCartEmpty = function _isCartEmpty() {
  return (headerCart.total() === 0);
};

// determine if the cart is replete with items
headerCart.updateCartIcon = function _updateCartIcon(cartDisplay) {
  const cartHasItems = !headerCart.isCartEmpty();
  const cartIcon = cartDisplay.querySelector('.MyCart__icon');
  
  let headerIcon__primary = Array.from(cartIcon.querySelectorAll('.HeaderIcon__primary'));
  headerIcon__primary.forEach(element => {
    element.classList.toggle('HeaderIcon__primary--active', cartHasItems);
  });

  let headerIcon__secondary = Array.from(cartIcon.querySelectorAll('.HeaderIcon__secondary'));
  headerIcon__secondary.forEach(element => {
    element.classList.toggle('HeaderIcon__secondary--active', cartHasItems);
  });
};

headerCart.forceInteger = function _forceInteger(value) {
  return value ? parseInt(value, 10) : 0;
};

headerCart.updateCartInfo = function _updateCartInfo() {
  const cartBtn = document.querySelector('.MyCart');

  headerCart.blinds = headerCart.forceInteger(cookieUtils.readBrowserCookie('Blinds_ComCartSamplesCount'));
  headerCart.mini = headerCart.getMinicartItemCount(document.cookie);

  // make public the fact that the cart drodpwn should be shown
  THD.HeaderFooter = {
    showCartDropdown: headerCart.showCartDropdown()
  };

  headerCart.updateCartTotal(cartBtn);

  headerCart.updateCartIcon(cartBtn);

  headerCart.updateCartUrl(cartBtn);
};

// on start determine to show cart dropdown, update totals, and change UI
headerCart.onDomReady = function _onDomReady() {
  headerCart.updateCartInfo();
};

headerCart.cartURLWithThrottle = function _cartURLWithThrottle() {
  return 'mycart/home';
};

// Default Value
headerCart.cartThrottle = true;

headerCart.init = function init() {
  $(document).on('cartUpdated', headerCart.updateCartInfo);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    headerCart.onDomReady();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      headerCart.onDomReady();
    })
  }

  return this;
};

headerCart.getPrivateMethods = () => headerCart;

export default headerCart;